import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule,
  FormGroup,
  Validators
} from '@angular/forms';
import { FieldsetModule } from 'primeng/fieldset';
import { InputTextarea } from 'primeng/inputtextarea';
import { TooltipModule } from 'primeng/tooltip';
import { sanitizeTextarea } from 'src/app/common/input-utils';
import { MAX_OBSERVACIONES_CUMPLIMIENTO } from 'src/app/common/constants-ejb';
import { ContadorCaracteresDirective } from 'src/app/presentation/shared/contador-caracteres/contador-caracteres.directive';

/**
 * DUMB COMPONENT: SeccionObservaciones
 *
 * Panel de observaciones generales.
 *
 * Legacy: CreateOrUpdateCumplimientoViewImpl.ui.xml líneas 387-396
 */
@Component({
  selector: 'app-seccion-observaciones',
  standalone: true,
  imports: [
    ContadorCaracteresDirective,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FieldsetModule,
    InputTextarea,
    TooltipModule
  ],
  template: `
    <p-fieldset legend="Observaciones" [toggleable]="true" styleClass="mb-4">
      <div [formGroup]="form()">
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Observaciones
          @if (form().get('observaciones')?.hasValidator(requiredValidator)) {
            <span class="text-red-500">*</span>
          }
        </label>
        <textarea
          pInputTextarea
          formControlName="observaciones"
          (input)="sanitizeObservaciones()"
          rows="4"
          class="w-full"
          [appContadorCaracteres]="maxObservaciones"
          pTooltip="Ingrese las observaciones"
        >
        </textarea>
      </div>
    </p-fieldset>
  `
})
export class SeccionObservacionesComponent {
  readonly maxObservaciones = MAX_OBSERVACIONES_CUMPLIMIENTO;
  form = input.required<FormGroup>();
  readonly requiredValidator = Validators.required;

  /**
   * Sanitiza el campo Observaciones contra XSS/SQLi (seguridad-girop §3).
   */
  sanitizeObservaciones(): void {
    const ctrl = this.form().get('observaciones');
    if (ctrl) {
      ctrl.setValue(sanitizeTextarea(ctrl.value ?? ''), { emitEvent: false });
    }
  }
}
